import script from "./Personal.vue?vue&type=script&lang=ts&setup=true"
export * from "./Personal.vue?vue&type=script&lang=ts&setup=true"

import "./Personal.vue?vue&type=style&index=0&id=054d6b98&scoped=true&lang=css"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/1fe6d5c2-02f8-4b7b-a7ed-3827401bba29/workspace/toilet-go-front_Ak2Q/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-054d6b98"]])

export default __exports__